import React from "react";

import BlockSelector from "../../../../Components/Inputs/Selects/BlockSelector";
import EntityConfigSection from "../../Components/EntityConfigSection";
import StackedFormRow from "../../../../Components/StackedForm/StackedFormRow";
import UnitSelector from "../../../../Components/Inputs/Selects/UnitSelector";
import UserGroupSelector from "../../../../Components/Inputs/Selects/UserGroupSelector";

const EntityRestrictionConfig = (props) => {

    const handleChange = (restrictionType, value) => {
        props.onChange(
            'restrictions',
            {
                ...props.restrictions,
                [restrictionType]: value
            }
        );
    }

    return (
        <EntityConfigSection
            title="Restrictions"
            tooltip="For specified users you can set booking limitations such as availability, maximum slots per day, etc. You can add more than one restriction for an amenity."
            isExpanded={props.isExpanded}
        >
            <StackedFormRow
                label="Blocks"
                labelClassName="margin-bottom-0"
            >
                <BlockSelector
                    module="admin"
                    multi
                    selected={props.restrictions.blocks}
                    onChange={handleChange}
                    placeholder=""
                />
                <p className="info-message">Leave blank to apply to all blocks</p>
            </StackedFormRow>

            <StackedFormRow
                label={window.siteType == 'RESIDENTIAL' ? 'Property' : 'Company'}
                labelClassName="margin-bottom-0"
            >
                <UnitSelector
                    module="admin"
                    multi
                    selected={props.restrictions.units}
                    blockIds={(props.restrictions.blocks) ? props.restrictions.blocks.map(obj => obj.value) : []}
                    onChange={handleChange}
                    preserveSelectedValues
                />
                <p className="info-message">
                    Leave blank to apply to all {window.siteType == 'RESIDENTIAL' ? 'properties' : 'companies'} within selected blocks
                </p>
            </StackedFormRow>

            <StackedFormRow
                label="User Group"
                labelClassName="margin-bottom-0"
            >
                <UserGroupSelector
                    module="admin"
                    multi
                    selected={props.restrictions.groups}
                    onChange={handleChange}
                />
                <p className="info-message">Leave blank to apply to all user groups</p>
            </StackedFormRow>
        </EntityConfigSection>
    )
}

EntityRestrictionConfig.defaultProps = {
    isExpanded: false,
}

export default EntityRestrictionConfig;
